import { createContext, useContext, useState, ReactNode } from "react";
import { IProductsProps } from "interfaces/Product";
import { IUser } from "interfaces/User";

type ClientContextData = {
  createdUser: IUser | undefined;
  setCreatedUser: (user: IUser) => void;
  createdProduct: IProductsProps | undefined;
  setCreatedProduct: (product: IProductsProps) => void;
};

type ContextProviderProps = {
  children: ReactNode;
};

export const ClientContext = createContext({} as ClientContextData);

export function ClientContextProvider({
  children,
}: ContextProviderProps): JSX.Element {
  const [createdUser, setCreatedUser] = useState<IUser | undefined>();

  const [createdProduct, setCreatedProduct] = useState<
    IProductsProps | undefined
  >();

  return (
    <ClientContext.Provider
      value={{
        createdUser,
        setCreatedUser,
        createdProduct,
        setCreatedProduct,
      }}
    >
      {children}
    </ClientContext.Provider>
  );
}

export const useClient = () => {
  return useContext(ClientContext);
};
